/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import { Row, Col, ToggleButton, Button, Form, Dropdown } from "react-bootstrap";

import { useAuth, useDispatcher } from "../../components/AuthProvider"
import { Icon } from "../../components/Icon";
import { formatDisplayDate } from '../../engine/date-helpers';



export default function Milestones(props) {
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  const results = useAuth();


  function handleAdd(item) {
    let path = `/app/planner/milestones/add`;
    navigate(path);
  }

  function handleEdit(item) {
    let path = `/app/planner/milestones/${item.baseID}/edit`;
    navigate(path);
  }

  function handleDelete(id) {
    let action = {
      type: 'deleteMilestone',
      id: id
    }

    dispatch(action);
  }

  
  let sim_model = results.simResults.simModel;
  let milestones = sim_model.milestones;
//  {milestones.map( (m,i) => { <Milestone key={i} milestone={m} />} )}


  let hd_style = {
    display: "inline-block"
  }


  return (
    <>
      <h3 style={hd_style}>Milestones</h3><span><Icon.Add onClick={handleAdd}/></span>
      {milestones.map( (m,i) => <Milestone key={i} simModel={sim_model} milestone={m} onEdit={handleEdit} onDelete={handleDelete} /> )}
    </>
  );
}


function Milestone(props) {

  function handleEdit(event) {
    event.preventDefault();
    props.onEdit(props.milestone);
  }

  function handleDelete(event) {
    event.preventDefault();
    props.onDelete(props.milestone.baseID); 
  }


  let has_dependents = props.simModel.getMilestoneDependencyCount(props.milestone.name) > 0;
  let del_icon = has_dependents === true ? <Icon.CantDelete/> : <Icon.Delete onClick={handleDelete}/>;
  let formated_date = formatDisplayDate(props.simModel.getMilestoneDate(props.milestone.name));

  return (
    <Row>
      <Col>{props.milestone.desc}</Col>
      <Col>{formated_date}</Col>
      <Col><Icon.Edit onClick={handleEdit}/>{del_icon}</Col>
    </Row>
  )
}